import {Screen} from 'src/types';
import * as Sentry from '@sentry/react';
import {getLogger} from 'src/utils/logger';

export class UserFacingError extends Error {}

export type ErrorCode =
  | 'wallet_and_currency_network_mismatch'
  | 'unsupported_network'
  | 'wallet_connected_to_different_account'
  | 'insufficient_balance'
  // Link errors START
  | 'link.error'
  | 'link.confirm_verification_error'
  | 'link.invalid_otp'
  | 'link.signup_error'
  // Link errors END
  | 'populate_name_error'
  | 'invalid_name'
  | 'invalid_phone_number'
  | 'invalid_email'
  // Payment errors START
  | 'pay.prepare_error'
  | 'pay.transaction_sending_error'
  | 'pay.transaction_rejected'
  | 'pay.wallet_verification_error'
  | 'pay.transaction_signing_abandoned'
  | 'pay.transaction_signing_expired'
  | 'pay.transaction_signing_network_error';

export type ScreenError = {
  error_message: string | JSX.Element;
  screen: Screen;
  error_code: ErrorCode;
  // (Optional) A specific input field on the screen that caused the error. This can be used to highlight the field in the UI.
  input?: 'Email' | 'Phone' | 'FirstName' | 'LastName';
};

export const handleUnexpectedError = (
  screen: Screen,
  error: Error | unknown,
) => {
  Sentry.captureException(error);
  getLogger().log('crypto_payin_session.error', {error});
};

// TODO(struong): consider setting up an error map. consumers would just specify
// an error key to render the right screen error. the pro of this is that we can
// centralize errors into one place, and then easily make changes to its struct
// over time as needed.
